<template>
  <v-card>
    <v-card-title class="d-flex justify-center">{{ mode }}</v-card-title>
    <div style="max-height: 80vh; overflow-y: auto; scrollbar-width: unset">
      <v-form
        @submit.prevent="submitForm"
        class="mx-4 my-1"
        ref="form"
        v-model="valid"
      >
        <v-alert
          v-if="preSettlement !== ''"
          outlined
          color="deep-orange"
          prominent
          border="left"
          type="warning"
          style="display: flex; justify-content: center"
        >
          {{ preSettlement }}
        </v-alert>

        <DateWithCheck v-if="showDate" :showCheck="showCheck" class="my-4" />

        <div v-for="field in sortedFields" :key="field.name">
          <template v-if="field.show">
            <v-menu
              v-if="field.typeInput === 'time'"
              v-model="field._menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="field.data"
                  :name="field.name"
                  :label="field.label"
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  :rules="rules"
                  placeholder="HH:mm"
                  append-icon="mdi-clock-outline"
                  readonly
                />
              </template>

              <v-time-picker v-model="field._tempTime" scrollable format="24hr">
                <v-btn
                  text
                  color="primary"
                  class="v-picker__actions"
                  @click="acceptTime(field)"
                >
                  Aceptar
                </v-btn>
              </v-time-picker>
            </v-menu>

            <v-menu
              v-else-if="field.typeInput === 'date'"
              v-model="field._menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-x
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="field.data"
                  v-bind="attrs"
                  v-on="on"
                  :name="field.name"
                  :label="field.label"
                  :disabled="field.disabled"
                  outlined
                  dense
                  append-icon="mdi-calendar"
                  placeholder="DD-MM-YYYY"
                  @input="onInput(field, $event)"
                />
              </template>

              <v-date-picker
                locale="es"
                first-day-of-week="1"
                @input="onPickDate(field, $event)"
              />
            </v-menu>
            <component
              v-else
              :is="getComponentName(field)"
              :name="field.name"
              v-model="field.data"
              @change="handleChange(field)"
              :type="field.typeInput"
              :label="field.label"
              :disabled="field.disabled"
              :rules="field.rules"
              :readonly="field.readonly"
              outlined
              dense
              :items="field.items"
              :item-text="field.itemText || 'text'"
              :item-value="field.itemValue || 'id'"
              :multiple="field.multiple"
            />
          </template>
        </div>
        <v-alert
          v-if="showLimitAlert"
          type="warning"
          dense
          outlined
          @input="showLimitAlert = false"
        >
          {{ $tc("gestionEmpleados.OnlyUpTo300Employees") }}
        </v-alert>
        <v-autocomplete
          :rules="rules"
          :label="$tc('schedules.employees')"
          outlined
          v-model="data.employees"
          :items="employeesWithSelectAll"
          multiple
          item-value="empId"
          item-text="fullName"
          :filter="customFilter"
          :search-input.sync="searchEmployee"
          v-if="
            employedOrigin &&
            employedOrigin.length > 0 &&
            mode === 'Agregar empleado '
          "
        >
          <template v-slot:item="{ item }">
            <v-list-item @click.stop="toggleItem(item)">
              <v-list-item-action>
                <v-checkbox
                  :input-value="isSelected(item)"
                  :indeterminate="isIndeterminate(item)"
                  dense
                  hide-details
                  readonly
                />
              </v-list-item-action>
              <v-list-item-content class="ml-n3">
                <v-list-item-title>{{
                  item.empId === "all"
                    ? item.fullName
                    : item.fullName + " (" + item.file + ")"
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 2">
              <span>{{
                item.empId === "all"
                  ? item.fullName
                  : item.fullName + " (" + item.file + ")"
              }}</span>
            </v-chip>
            <span v-if="index === 2" class="grey--text text-caption">
              (+ {{ data.employees.length - 2 }} )
            </span>
          </template>
        </v-autocomplete>
        <v-text-field
          v-if="mode === 'Editar empleado '"
          label="Empleado"
          outlined
          dense
          :value="infoEmployee?.name"
          disabled
        />

        <div
          v-for="(slider, i) in inputSlider"
          :key="'slider_' + i + slider.name"
          v-show="show"
          class="slider-container mb-6"
        >
          <v-slider
            class="mx-10"
            :value="slider.data"
            @change="handleSliderChange(slider)"
            v-model="slider.data"
            :max="slider.max"
            :min="slider.min"
            step="60"
          >
            <template v-slot:thumb-label="{ value }">
              {{ formatHours(value) }}
            </template>
          </v-slider>
        </div>

        <div class="d-flex justify-space-between">
          <v-btn class="bt-exit mb-4" @click="cancel">
            {{ $tc("editRegistrations.cancel") }}
          </v-btn>
          <v-btn type="submit" class="bt-acept">
            {{ $tc("editRegistrations.acept") }}
          </v-btn>
        </div>
      </v-form>
    </div>
  </v-card>
</template>

<script>
import Vue from "vue";
import { VSelect, VAutocomplete, VTextField, VCheckbox } from "vuetify/lib";
Vue.component("v-select", VSelect);
Vue.component("v-autocomplete", VAutocomplete);
Vue.component("v-text-field", VTextField);
Vue.component("v-checkbox", VCheckbox);
import DateWithCheck from "./DateWithCheck.vue";

export default {
  components: { DateWithCheck },
  props: {
    allFields: Array,
    mode: String,
    itemsSlider: Array,
    show: Boolean,
    showDate: Boolean,
    showCheck: Boolean,
    preSettlement: {
      type: String,
      default: "",
    },
    employedOrigin: {
      type: Array,
      default: () => [],
    },
    infoEmployee: Object,
    employeesWithSelectAll: { type: Array, default: () => [] },
  },
  data() {
    return {
      items: {},
      valid: true,
      error: false,
      alertValidate: "",
      inputSlider: [],
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      data: {
        employees: [],
      },
      searchEmployee: "",
      maxEmployees: 300,
      showLimitAlert: false,
    };
  },

  mounted() {
    if (this.allFields) this.items = Vue.observable(this.allFields);
    if (this.itemsSlider) this.inputSlider = Vue.observable(this.itemsSlider);
    this.items.forEach((f) => {
      if (f.typeInput === "date") {
        this.$set(f, "_menu", false);
      }
      if (f.typeInput === "time") {
        this.$set(f, "_menu", false);
        this.$set(f, "_tempTime", f.data || "");
      }
    });
  },

  computed: {
    sortedFields() {
      const arr = Array.isArray(this.items)
        ? this.items
        : Object.values(this.items || {});
      return arr.slice().sort((a, b) => a.order - b.order);
    },
  },

  watch: {
    allFields: {
      immediate: true,
      handler(value) {
        if (value) this.items = value;
      },
    },
  },

  methods: {
    isSelected(item) {
      if (item.empId === "all") {
        return this.data.employees.length === this.employedOrigin.length;
      }

      return this.data.employees.includes(item.empId);
    },

    isIndeterminate(item) {
      if (item.empId !== "all") return false;

      return (
        this.data.employees.length > 0 &&
        this.data.employees.length < this.employedOrigin.length
      );
    },

    toggleItem(item) {
      if (item.empId === "all") {
        const isAllSelected = this.data.employees.length > 0;

        if (isAllSelected) {
          this.data.employees = [];
          this.showLimitAlert = false;
        } else {
          const allIds = this.employedOrigin.map((e) => e.empId);

          if (allIds.length > this.maxEmployees) {
            this.data.employees = allIds.slice(0, this.maxEmployees);
            this.showLimitAlert = true;
          } else {
            this.data.employees = allIds;
            this.showLimitAlert = false;
          }
        }

        this.searchEmployee = "";
        return;
      }

      const exists = this.data.employees.includes(item.empId);

      if (exists) {
        this.data.employees = this.data.employees.filter(
          (id) => id !== item.empId
        );
        this.showLimitAlert = false;
      } else {
        if (this.data.employees.length >= this.maxEmployees) {
          this.showLimitAlert = true;
          return;
        }

        this.data.employees = [...this.data.employees, item.empId];

        if (this.data.employees.length === this.maxEmployees) {
          this.showLimitAlert = true;
        } else {
          this.showLimitAlert = false;
        }
      }

      this.searchEmployee = "";
    },

    customFilter(item, queryText) {
      const search = queryText.toLowerCase();

      return (
        item.fullName?.toLowerCase().includes(search) ||
        item.file?.toString().toLowerCase().includes(search)
      );
    },
    acceptTime(field) {
      field.data = field._tempTime || "";
      field._menu = false;
    },
    onInput(field, value) {
      let v = value.replace(/[^\d]/g, "").slice(0, 8);
      if (v.length >= 5) v = v.replace(/^(\d{2})(\d{2})(\d{0,4})$/, "$1-$2-$3");
      else if (v.length >= 3) v = v.replace(/^(\d{2})(\d{0,2})$/, "$1-$2");
      field.data = v;
    },

    onPickDate(field, value) {
      const [y, m, d] = value.split("-");
      field.data = `${d}-${m}-${y}`;
      field._menu = false;
    },

    getComponentName(field) {
      if (field.type === "select") return "v-autocomplete";
      if (field.type === "check") return "v-checkbox";
      if (field.type === "boolean") return "v-checkbox";
      return "v-text-field";
    },

    submitForm(e) {
      if (e) e.preventDefault();
      this.validation();
    },

    handleSubmit() {
      const itemsComplete = {};

      this.items.forEach((field) => {
        itemsComplete[field.name] = field.data;
      });

      if (this.data.employees.length > 0) {
        itemsComplete.employees = this.data.employees;
      }

      this.$emit("save", itemsComplete);
      this.data.employees = [];
      this.showLimitAlert = false;
    },

    cancel() {
      this.$emit("cancel", false);
      this.data.employees = [];
      this.showLimitAlert = false;
    },

    validation() {
      let valid = this.$refs.form.validate();
      if (valid) this.handleSubmit();
    },

    handleSliderChange(slider) {
      let item = {};
      item[slider.name] = slider.data;
      this.$emit("changeSlider", item);
    },

    formatHours(value) {
      const h = Math.floor(value / 60);
      const m = value % 60;
      return `${h}:${m.toString().padStart(2, "0")}`;
    },

    handleChange(item) {
      this.$emit("itemUpdate", item);
    },
  },
};
</script>
<style scoped>
.slider-input {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}

.slider-container {
  border: 1px solid #959595;
  height: 90px;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
